var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sushi-market-charts"},[_c('div',{staticClass:"sushi-market-charts__title"},[_vm._v("\n    Charts\n  ")]),_vm._v(" "),_c('div',{staticClass:"sushi-market-charts__content"},[_c('market-charts',{key:("chart-extra-" + (_vm.isLayoutDesktop.toString())),attrs:{"market":_vm.market}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e76c5910","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/page-market-detail-sushi/pages/sushi-market-charts/sushi-market-charts.vue
// module id = xb6r
// module chunks = 0